import { Card, CardContent, TextField } from "@material-ui/core";
import { AnnouncementCreate_announcementCreate_errors } from "@saleor/announcements/types/AnnouncementCreate";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { FormChange } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getAnnouncementErrorMessage from "@saleor/utils/errors/announcement";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

import { AnnouncementFormData } from "../AnnouncementCreatePage";

export interface AnnouncementInfoProps {
  data: AnnouncementFormData;
  errors: AnnouncementCreate_announcementCreate_errors[];
  disabled: boolean;
  localError: { endDate: string; title: string; startDate: string };
  onChange: FormChange;
}

const AnnouncementInfo: React.FC<AnnouncementInfoProps> = props => {
  const { data, disabled, onChange, localError, errors } = props;
  const intl = useIntl();

  const formErrors = getFormErrors(
    ["title", "startDate", "endDate"],
    errors || []
  );

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          id="titleTxt"
          error={!!formErrors.title || !!localError.title}
          helperText={
            !!localError.title
              ? localError.title
              : getAnnouncementErrorMessage(formErrors.title, intl)
          }
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "Title",
            description: "announcement title"
          })}
          name="title"
          value={data.title}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          id="startDateTxt"
          disabled={disabled}
          error={!!formErrors.startDate || !!localError.startDate}
          helperText={
            !!localError.startDate
              ? localError.startDate
              : getAnnouncementErrorMessage(formErrors.startDate, intl)
          }
          name="startDate"
          onChange={onChange}
          label={intl.formatMessage(commonMessages.startDate)}
          value={data.startDate}
          type="date"
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            inputProps: {
              min: moment(new Date()).format("YYYY-MM-DD")
            }
          }}
          fullWidth
        />
        <FormSpacer />
        <TextField
          id="endDateTxt"
          disabled={disabled}
          error={!!formErrors.endDate || !!localError.endDate}
          helperText={
            !!localError.endDate
              ? localError.endDate
              : getAnnouncementErrorMessage(formErrors.endDate, intl)
          }
          name="endDate"
          onChange={onChange}
          label={intl.formatMessage(commonMessages.endDate)}
          value={data.endDate}
          type="date"
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            inputProps: {
              min: moment(data.startDate)
                .add(1, "d")
                .format("YYYY-MM-DD")
            }
          }}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};

export default AnnouncementInfo;
